import { CarConfiMarketConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { MonthlyRateFragment, PartRateFragment, PriceFragment, PriceSummaryQuery } from '../__generated__/graphql';

export function mapPriceSummary(response: PriceSummaryQuery, config: CarConfiMarketConfiguration) {
	const totalPriceFrom = config.uiPreferences?.prices?.totalPriceFrom ?? 'total';

	return {
		parts: response.priceSummary.prices?.priceParts,
		totalPrice: response.priceSummary.prices?.priceParts.find((part) => part.type === totalPriceFrom)?.price,
		monthlyRate: response.priceSummary.prices?.monthlyRate,
		priceDate: response.priceSummary.prices?.priceDate,
	};
}

export type PriceSummary = ReturnType<typeof mapPriceSummary>;

export type PriceOrError = PriceFragment | MonthlyRateFragment | PartRateFragment;

/** @deprecated  Avoid using this type, components should handle error case. */
export type PriceInfo = Exclude<PriceOrError, { __typename: 'FinancingError' }>;
